import { Frameworks } from '@trustero/trustero-api-web/lib/model/framework_pb'
import { GetPolicyFrameworksRequest } from '@trustero/trustero-api-web/lib/model/policy_pb'
import { PolicyPromiseClient } from '@trustero/trustero-api-web/lib/model/policy_grpc_web_pb'
import { useSwrImmutableGrpc } from '../../../async/useSwrImmutableGrpc'
import { GrpcResponse, NewGrpcResponse } from '../../../async/hooks/types'

export const usePolicyFrameworks = (id: string): GrpcResponse<Frameworks> => {
  const { response } = useSwrImmutableGrpc(
    PolicyPromiseClient.prototype.getFrameworks,
    new GetPolicyFrameworksRequest().setId(id),
  )
  return NewGrpcResponse(response)
}
